import { getBorderColor } from 'utils/ui/colors';
function borderValue(theme) {
  return "1px solid ".concat(getBorderColor(theme));
}
export default borderValue;